import $ from 'jquery';
import React, { PropTypes } from 'react';
import ReactDOMServer from 'react-dom/server';
import fetch from 'utils/fetch';
import { error } from './toastr';

const DEFAULT_METHOD = 'PUT';

export default function bind() {
  $('table tr .button.action').on('click', evt => {
    evt.preventDefault();

    const $button = $(evt.currentTarget);

    const url = $button.attr('data-url');
    const method = $button.attr('data-method') || DEFAULT_METHOD;
    const title = $button.attr('data-title');
    const content = $button.attr('data-content');

    if (url && title && content) {
      const actionPromise = () =>
        fetch(url, {
          method,
        }).then(
          res => window.location.replace(res.url),
          err => {
            console.log('Error attempting to execute action', err);

            error("Une erreur est survenue pendant l`exécution de l'action");
          }
        );

      displayConfirmModal(title, content, actionPromise);
    }
  });
}

function displayConfirmModal(title, content, promiseFunc) {
  // Display modal
  const modal = ReactDOMServer.renderToStaticMarkup(
    <ConfirmModal title={title} content={content} />
  );

  // Appending content to body
  $(document.body).append(modal);

  // Handling approve button
  const $modal = $('#table-action-modal');
  $modal
    .modal({
      onApprove: element => {
        $(element).addClass('loading');
        promiseFunc().then(res => {
          $(element).removeClass('loading');
          $modal.modal('hide');
        });

        return false;
      },
    })
    .modal('show');
}

const ConfirmModal = ({ title, content }) => (
  <div id="table-action-modal" className="ui small modal">
    <div className="header">{title}</div>
    <div className="content">
      <p>{content}</p>
    </div>
    <div className="actions">
      <div className="ui red approve button">Confirmer</div>
      <div className="ui cancel button">Annuler</div>
    </div>
  </div>
);

ConfirmModal.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/plugins/table-action.js